'use client'

import {
	createProductCardStore,
	type ProductCardInitialState,
} from 'product-card/store/productCardStore'
import { createContext, type ReactNode, useRef } from 'react'

export type ProductCardStoreApi = ReturnType<typeof createProductCardStore>

export const ProductCardStoreContext = createContext<
	ProductCardStoreApi | undefined
>(undefined)

export interface ProductCardStoreProviderProps extends ProductCardInitialState {
	readonly children: ReactNode
}

export const ProductCardStoreProvider = ({
	children,
	...initialState
}: ProductCardStoreProviderProps) => {
	const storeRef = useRef<ProductCardStoreApi | null>(null)
	if (storeRef.current === null) {
		storeRef.current = createProductCardStore(initialState)
	}

	return (
		<ProductCardStoreContext.Provider value={storeRef.current}>
			{children}
		</ProductCardStoreContext.Provider>
	)
}
